import { FC, ReactNode } from "react";

import { env } from "config";

export const DevPartial: FC<{ children?: ReactNode }> = ({ children }) => {
  const isDev = env === "development" || env === "staging";

  return isDev ? <>{children}</> : null;
};

export default DevPartial;
